import { Controller } from "@hotwired/stimulus"
import { afterOnboarding } from "../lib/onboarding"
import { pageCovered } from "../lib/overlay"
import { lockScroll, unlockScroll } from "../lib/scroll_lock"
import { NativeBridge } from "../lib/native_bridge"

const COVERED_RETRY_MS = 1500
const DAY_MS = 24 * 60 * 60 * 1000

// UI::AppUpdatePromptComponent. Recommended: once onboarding is done, the tab is on screen and nothing else is open;
// 稍後再說 (or system back) snoozes this version for snoozeDays on this device. Required: at once, over everything.
// The native tab bar hides while it is open (it would float, undimmed and tappable, over the sheet).
export default class extends Controller {
  static values = { required: Boolean, version: String, snoozeDays: Number }

  connect() {
    if (this.requiredValue) {
      this.show()
      return
    }
    if (this.snoozed()) return
    this.cancelWait = afterOnboarding(() => this.show())
  }

  disconnect() {
    this.cancelWait?.()
    clearTimeout(this.timer)
    this.release()
  }

  show() {
    if (!this.requiredValue) {
      if (this.snoozed()) return // another tab snoozed it meanwhile
      if (pageCovered()) {
        this.timer = setTimeout(() => this.show(), COVERED_RETRY_MS)
        return
      }
    }
    this.element.hidden = false
    requestAnimationFrame(() => this.element.classList.add("is-open"))
    lockScroll(this, this.requiredValue ? {} : { dismiss: () => this.later() })
    NativeBridge.TabBar.hide()
    this.hidTabBar = true
  }

  release() {
    unlockScroll(this)
    if (this.hidTabBar) NativeBridge.TabBar.show()
    this.hidTabBar = false
  }

  later() {
    if (this.requiredValue) return
    try {
      localStorage.setItem(this.snoozeKey, String(Date.now() + this.snoozeDaysValue * DAY_MS))
    } catch {
      // private mode: it asks again on the next page
    }
    this.element.classList.remove("is-open")
    this.element.hidden = true
    this.release()
  }

  snoozed() {
    try {
      return Number(localStorage.getItem(this.snoozeKey)) > Date.now()
    } catch {
      return false
    }
  }

  get snoozeKey() {
    return `app_update_snooze:${this.versionValue}`
  }
}
